<zimmerer-route-ion-wrapper class="ion-page">

  <div class="threecol" fxLayout="column" fxLayoutAlign.gt-md="center center">
    <div class="main-col noSlider" fxLayout="column" fxLayoutGap="20px">

      <!-- breadcrumb -->
      <div><span (click)="StateService.goto('/job')"
          style="text-decoration: underline; cursor: pointer;">Jobbörse</span> > Inserat
        {{edit?"bearbeiten":"erstellen"}}
      </div>

      <div fxLayout="column" fxLayoutAlign="center center">
        <form [formGroup]="form" *ngIf="form && userService.user">

          <mat-horizontal-stepper linear #stepper class="createStepper">

            <mat-step label="step 1" [completed]="stepsCompleted>0">
              <div fxLayout="column" fxLayoutGap="25px">

                <ng-template matStepLabel>
                  Land auswählen
                </ng-template>

                <div>
                  <div class="title">
                    Hier kannst Du eine Stellenanzeige oder ein Stellengesuch erstellen.
                  </div>
                  <div class="subtitle">
                    Für Handwerksbetriebe ist das kostenlos.
                  </div>
                </div>

                <div fxLayout="column" fxLayoutGap.lt-lg="20px" fxLayout.gt-md="row">

                  <!-- create as -->
                  <div fxFlex="grow">
                    <div class="fat1">Profil</div>
                    <div style="margin-top: 0.4375em; margin-bottom: 0.4375em;">
                      <profile-selector [form]="form">
                      </profile-selector>
                    </div>
                  </div>

                  <!-- separator line -->
                  <div *ngIf="!Mobileservice.isMobile" style="border-right: 1px solid lightgray; margin: 0px 30px;">
                  </div>

                  <!-- Category -->
                  <div fxFlex="grow">

                    <div class="fat1">Land wählen</div>

                    <mat-form-field>
                      <app-category-selection formControlName="category" [inputCategories]="{type: CategoryType.job}"
                        [onlySecondLevelSelectable]="true">
                      </app-category-selection>
                    </mat-form-field>
                    <div>
                      <mat-error
                        *ngIf="(formSubmitted || form.get('category').touched) && form.get('category').hasError('required')">
                        *Bitte wähle ein Land aus
                      </mat-error>
                    </div>
                  </div>

                </div>

                <app-credits-warning [is_edit]="draft.is_edit" [profile_type]="form.get('profile_type').value"
                  [entity_type]="'JOB'" [company_profile]="userService.getCompanyProfile()">
                </app-credits-warning>

                <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="10px">
                  <button (click)="nextIfFormValid(false,['profile_type','category'])" class="orange-button">
                    Weiter
                  </button>
                </div>

              </div>
            </mat-step>

            <!-- details -->
            <mat-step label="step 2" [completed]="stepsCompleted>1">

              <ng-template matStepLabel>
                Details angeben
              </ng-template>

              <div fxLayout="column" fxLayoutGap="20px">

                <div fxHide.gt-md class="title">Details angeben</div>

                <!-- title -->
                <div fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutGap.lt-lg="0px">

                  <div fxFlex="20" fxLayout="row" fxLayoutAlign="start center" class="fieldHeadline">
                    Titel des Inserats
                  </div>

                  <div class="full-width-input">
                    <mat-form-field>
                      <input matInput placeholder="Titel" type="text" formControlName="title" (blur)="updateDraft()">

                      <div>
                        <mat-error
                          *ngIf="(formSubmitted || form.get('title').touched) && form.get('title').hasError('required')">
                          *Titel ist ein Pflichtfeld
                        </mat-error>
                        <mat-error
                          *ngIf="(formSubmitted || form.get('title').touched) && form.get('title').hasError('minlength')">
                          *Titel muss min. 3 Zeichen lang sein
                        </mat-error>
                        <mat-error
                          *ngIf="(formSubmitted || form.get('title').touched) && form.get('title').hasError('maxlength')">
                          *Titel darf max. 254 Zeichen lang sein
                        </mat-error>
                      </div>

                    </mat-form-field>
                  </div>
                </div>

                <!-- PLZ Ort Region -->
                <div fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutGap.lt-lg="0px">

                  <div fxFlex="20" fxLayout="row" fxLayoutAlign="start center" class="fieldHeadline">
                    PLZ / Ort / Region
                  </div>

                  <div class="full-width-input">
                    <mat-form-field>
                      <input matInput placeholder="PLZ / Ort / Region" type="text" formControlName="subtitle"
                        (blur)="updateDraft()">

                      <div>
                        <mat-error
                          *ngIf="(formSubmitted || form.get('subtitle').touched) && form.get('subtitle').hasError('required')">
                          *PLZ / Ort / Region ist ein Pflichtfeld
                        </mat-error>
                        <mat-error
                          *ngIf="(formSubmitted || form.get('subtitle').touched) && form.get('subtitle').hasError('minlength')">
                          *PLZ / Ort / Region muss min. 3 Zeichen lang sein
                        </mat-error>
                        <mat-error
                          *ngIf="(formSubmitted || form.get('subtitle').touched) && form.get('subtitle').hasError('maxlength')">
                          *PLZ / Ort / Region darf max. 254 Zeichen lang sein
                        </mat-error>
                      </div>
                    </mat-form-field>
                  </div>
                </div>

                <!-- teaser text -->
                <div fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutGap.lt-lg="0px">

                  <div fxFlex="20" fxLayout="row" fxLayoutAlign="start center" class="fieldHeadline">
                    Kurzbeschreibung
                  </div>

                  <div class="full-width-input">
                    <mat-form-field>

                      <textarea
                        style="width: 100%; min-height: 100px; padding: 10px 10px;text-indent: 0px; box-sizing: border-box;"
                        class="zimTextarea" matInput placeholder="Teaser Text" formControlName="teaser"
                        (blur)="updateDraft()" autoresize>
                      </textarea>

                      <div>
                        <mat-error
                          *ngIf="(formSubmitted || form.get('teaser').touched) && form.get('teaser').hasError('required')">
                          *Teaser Text ist ein Pflichtfeld
                        </mat-error>
                        <mat-error
                          *ngIf="(formSubmitted || form.get('teaser').touched) && form.get('teaser').hasError('minlength')">
                          *Teaser Text muss min. 3 Zeichen lang sein
                        </mat-error>
                        <mat-error
                          *ngIf="(formSubmitted || form.get('teaser').touched) && form.get('teaser').hasError('maxlength')">
                          *Teaser Text darf max. 25000 Zeichen lang sein
                        </mat-error>
                      </div>
                    </mat-form-field>
                  </div>
                </div>

                <!-- main image -->
                <div fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutGap.lt-lg="0px">

                  <mat-form-field style="display: none;">
                    <app-image-formcontrol matInput formControlName="mainImage"></app-image-formcontrol>
                  </mat-form-field>

                  <div fxFlex="20" fxLayout="row" fxLayoutAlign="start center" class="fieldHeadline">
                    Hauptbild
                  </div>

                  <div style="padding: 0.4375em 0;">

                    <div *ngIf="draft.mainImage" style="margin-bottom: 10px;">
                      <edit-images *ngIf="draft.mainImage" [images]="[draft.mainImage]"
                        [deleteImage]="deleteImage.bind(this)" [key]="'MAIN,SLIDE'">
                      </edit-images>
                    </div>

                    <image-upload-box *ngIf="!draft.mainImage" [fileSelected]="fileSelected.bind(this)"
                      [fileDropped]="fileDropped.bind(this)" [key]="'MAIN,SLIDE'" [multiple]="false">
                    </image-upload-box>

                    <mat-error
                      *ngIf="(formSubmitted || form.get('mainImage').touched) && form.get('mainImage').hasError('required')">
                      *Bitte lade ein Hauptbild hoch
                    </mat-error>

                  </div>
                </div>

                <!-- images -->
                <div fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutGap.lt-lg="0px">

                  <div fxFlex="20" fxLayout="row" fxLayoutAlign="start center" class="fieldHeadline">
                    Bilder
                  </div>

                  <div style="padding: 0.4375em 0;">

                    <div *ngIf="draft.images.length" style="margin-bottom: 10px;">
                      <edit-images [images]="draft.images" [deleteImage]="deleteImage.bind(this)" [key]="'SLIDE'">
                      </edit-images>
                    </div>

                    <image-upload-box [fileSelected]="fileSelected.bind(this)" [fileDropped]="fileDropped.bind(this)"
                      [key]="'SLIDE'">
                    </image-upload-box>

                  </div>
                </div>

                <!-- content -->
                <div fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutGap.lt-lg="0px">

                  <div fxFlex="20" fxLayout="row" fxLayoutAlign="start center" class="fieldHeadline">
                    Beschreibungstext
                  </div>

                  <div fxFlex="grow" style="padding: 0.4375em 0;">

                    <editor apiKey="cirw0hv94c52sgyqp5rseuz1djp09a8nptls2c9a41ypi805" [init]="tinyDefaultConfig"
                      [formControlName]="'content'" (onBlur)="updateDraft()">
                    </editor>

                    <div>
                      <mat-error
                        *ngIf="(formSubmitted || form.get('content').touched) && form.get('content').hasError('required')">
                        *Beschreibungstext ist ein Pflichtfeld
                      </mat-error>
                      <mat-error
                        *ngIf="(formSubmitted || form.get('content').touched) && form.get('content').hasError('minlength')">
                        *Beschreibungstext muss min. 3 Zeichen lang sein
                      </mat-error>
                      <mat-error
                        *ngIf="(formSubmitted || form.get('content').touched) && form.get('content').hasError('maxlength')">
                        *Beschreibungstext darf max. 25000 Zeichen lang sein
                      </mat-error>
                    </div>

                  </div>
                </div>

                <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="10px">
                  <div *ngIf="formSubmitted && form.invalid" class="form-validation-errors">
                    <div class="form-validation-error">Bitte prüfe deine Eingaben.</div>
                  </div>
                </div>

                <app-credits-warning [is_edit]="draft.is_edit" [profile_type]="form.get('profile_type').value"
                  [entity_type]="'JOB'" [company_profile]="userService.getCompanyProfile()">
                </app-credits-warning>

                <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="10px">
                  <button class="black-button" matStepperPrevious>Zurück</button>
                  <button class="orange-button" (click)="nextIfFormValid(false)">Weiter</button>
                </div>
              </div>
            </mat-step>

            <!-- preview -->
            <mat-step label="preview" [completed]="stepsCompleted>2">

              <ng-template matStepLabel>
                Vorschau
              </ng-template>

              <div fxLayout="column" fxLayoutGap="20px">

                <app-job-display *ngIf="currentStepLabel == 'preview'" [live]="false" [entity]="draft">
                </app-job-display>

                <app-credits-warning [is_edit]="draft.is_edit" [profile_type]="form.get('profile_type').value"
                  [entity_type]="'JOB'" [company_profile]="userService.getCompanyProfile()">
                </app-credits-warning>

                <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="10px">
                  <button matStepperPrevious>Zurück</button>
                  <button class="orange-button" (click)="publish()">Veröffentlichen</button>
                </div>
              </div>
            </mat-step>

            <!-- finish -->
            <mat-step label="last step" [completed]="stepsCompleted>3">

              <ng-template matStepLabel>Geschafft!</ng-template>

              <div fxLayout="column" fxLayoutGap="20px">

                <div>
                  <b>Geschafft!</b><br>
                  Dein Inserat wird in Kürze online sein!
                </div>

                <div *ngIf="draft.accepted_by_admin">
                  <p>Inserat teilen:</p>

                  <share-buttons
                    [include]="Mobileservice.isMobile ? appConfig.shareconfig_mobile : appConfig.shareconfig_desktop"
                    [show]="appConfig.sharebuttonsmax" [showText]="true" [url]="draft.getOpgraphData().url"
                    [autoSetMeta]="false" description=" "></share-buttons>
                </div>

                <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutAlign="end center" fxLayoutGap="10px">
                  <button class="dark-grey-button" (click)="goToCreate()">
                    <span fxHide.lt-lg>Weiteres Inserat erstellen</span>
                    <span fxHide.gt-md>Weiteres Inserat</span>
                  </button>
                  <button class="dark-grey-button" (click)="goBackToList()">
                    <span fxHide.lt-lg="true">Zurück zur Übersicht</span>
                    <span fxHide.gt-md="true">Zur Übersicht</span>
                  </button>
                </div>
              </div>

            </mat-step>

          </mat-horizontal-stepper>

        </form>
      </div>

      <div class="related">
        <app-job-related-items [direction]="'horizontal'" [items]="mostViewed"
          [title]="'Das könnte dich auch interessieren'"
          *ngIf="mostViewed && mostViewed.length > 0 && currentStepLabel == 'last step'">
        </app-job-related-items>
      </div>

    </div>
  </div>


</zimmerer-route-ion-wrapper>